export default __webpack_public_path__ + "assets/903b66b64419cf988e514cd216b4131e.png";